import PlanService from '@/services/PlanService'

const state = {
    plans: {},
    selected: null,
}

const actions = {
    fetch({ commit }, { key, companyUuid, providerUuid, planUuid, platform, cc }) {
        const planService = new PlanService(key)

        planService
            .get({
                companyUuid,
                providerUuid,
                planUuid,
                platform,
                cc,
            })
            .then((response) => commit('SET_RENTAL_PLAN', response.data))
            .catch((err) => console.log(err))
    },
    select({ commit }, id) {
        commit('SELECT', id)
    },
    setPack({ commit }, id) {
        commit('SELECT_PACK', id)
    },
}

const mutations = {
    SELECT(state, id) {
        Object.assign(state, { selected: id })
    },
    SET_RENTAL_PLAN(state, plan) {
        state.plans[plan.uuid] = plan
    },
}

const getters = {
    selected(state) {
        return state.selected
    },
    plans(state) {
        return state.plans
    },
    price(state, getters, rootState, rootGetters) {
        const { cc } = rootGetters['settings/get']

        // eslint-disable-next-line func-names
        return function (plan) {
            const sku = plan.prices.find((sku) => sku.country_code === cc)

            return new Intl.NumberFormat(`en-${cc}`, {
                style: 'currency',
                currency: sku.currency_code,
                currencyDisplay: 'symbol',
            }).format(sku.price / 100)
        }
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
